import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0;
`;

export const ChartBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  margin: 0;

  @media (max-width: 1740px) {
    min-width: auto;
  }
`;
